export default __webpack_public_path__ + "static/media/19.44b0fe43.jpg";